import React from "react";
import { useNavigate } from "react-router-dom";

interface ProductCardProps {
  name: string;
}

const ProduitCard = (props: ProductCardProps) => {
  const navigate = useNavigate();
  const { name } = props;

  return (
    <div
      className="max-w-xs  rounded overflow-hidden shadow-lg bg-white mx-auto"
      onClick={() => navigate("/detail_produit")}
      style={{ cursor: "pointer" }}
    >
      <div className="relative">
        
        <img
          className="w-[300px] h-48 object-cover"
          src="/assets/im3.jpg"
          alt="Produit"
        />
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <span className="text-black text-2xl font-bold">{name}</span>
        </div>
      </div>

      <div className="px-6 py-4">
        <p className="text-gray-700 text-base">Haricot Noir</p>
      </div>

      <div className="px-6 pt-4 pb-6 text-md ">10,000 FCFA</div>
    </div>
  );
};

export default ProduitCard;
